module.exports = __webpack_public_path__ + "static/assets/4a437fc9276d578f4952d2aedc86a170.jpg";